class SpeciesTabs extends HTMLElement {
  connectedCallback() {
    this._section = this.closest('.custom-species-tabs');
    this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this._panels = Array.from(this._section?.querySelectorAll('[data-tab-panel]') || []);
    this._tabs.forEach((tab) => {
      tab.addEventListener('click', this._onTabClick.bind(this));
      tab.addEventListener('keydown', this._onTabKeydown.bind(this));
    });

    this.addEventListener('change', (event) => {
      if (event.target && event.target.name === 'sort_by') this._onSortChange();
    });

    const initialPanel = this._panels.find((p) => !p.hidden);
    const initialSort = this._currentSort();
    if (initialPanel && initialSort && initialSort !== 'manual') {
      this._sortPanel(initialPanel, initialSort);
    }
  }

  _currentSort() {
    const checked = this.querySelector('input[name="sort_by"]:checked');
    if (checked) return checked.value;
    const select = this.querySelector('select[name="sort_by"]');
    return select ? select.value : 'manual';
  }

  _onTabClick(event) {
    const tab = event.currentTarget;
    if (tab.getAttribute('aria-selected') === 'true') return;
    this._activate(tab);
  }

  _onTabKeydown(event) {
    const idx = this._tabs.indexOf(event.currentTarget);
    if (idx < 0) return;
    let next = -1;
    switch (event.key) {
      case 'ArrowRight':
        next = (idx + 1) % this._tabs.length;
        break;
      case 'ArrowLeft':
        next = (idx - 1 + this._tabs.length) % this._tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = this._tabs.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    const target = this._tabs[next];
    target.focus();
    target.click();
  }

  _onSortChange() {
    const activePanel = this._panels.find((p) => !p.hidden);
    if (activePanel) this._sortPanel(activePanel, this._currentSort());
    this._updateSortStatus();
  }

  _updateSortStatus() {
    const checked = this.querySelector('input[name="sort_by"]:checked');
    const status = this.querySelector('.facets__status');
    if (checked && status) status.textContent = checked.dataset.optionName || '';
  }

  _activate(tab) {
    const handle = tab.dataset.tabHandle;

    this._tabs.forEach((t) => {
      const isActive = t === tab;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
      t.classList.toggle('custom-species-tabs__tab--active', isActive);
    });

    let active = null;
    this._panels.forEach((panel) => {
      const matches = panel.dataset.tabPanel === handle;
      panel.hidden = !matches;
      if (matches) active = panel;
    });

    if (active) {
      this._hydrate(active);
      this._sortPanel(active, this._currentSort());
    }

    if (this._section) this._section.dataset.activeTab = handle;
  }

  _hydrate(panel) {
    const tmpl = panel.querySelector(':scope > template[data-tab-content]');
    if (!tmpl) return;
    panel.insertAdjacentHTML('beforeend', tmpl.innerHTML);
    tmpl.remove();
  }

  _sortPanel(panel, criterion) {
    const grid = panel.querySelector('.custom-species-tabs__grid');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('.custom-species-tabs__grid-item'));
    if (items.length < 2) return;

    const compare = (a, b) => {
      switch (criterion) {
        case 'title-ascending':
          return a.dataset.productTitle.localeCompare(b.dataset.productTitle);
        case 'title-descending':
          return b.dataset.productTitle.localeCompare(a.dataset.productTitle);
        case 'price-ascending':
          return parseFloat(a.dataset.productPrice) - parseFloat(b.dataset.productPrice);
        case 'price-descending':
          return parseFloat(b.dataset.productPrice) - parseFloat(a.dataset.productPrice);
        case 'created-ascending':
          return parseInt(a.dataset.productCreated, 10) - parseInt(b.dataset.productCreated, 10);
        case 'created-descending':
          return parseInt(b.dataset.productCreated, 10) - parseInt(a.dataset.productCreated, 10);
        default:
          return parseInt(a.dataset.productPosition, 10) - parseInt(b.dataset.productPosition, 10);
      }
    };

    items.sort(compare).forEach((item) => grid.appendChild(item));
  }
}

if (!customElements.get('species-tabs')) {
  customElements.define('species-tabs', SpeciesTabs);
}
